/**
 * @generated SignedSource<<45ffa2b3ed57a4f832d4c644f0f5907e>>
 * @relayHash a3f93252d4df99f3c4003e78531fafc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df71df8a37a95b7e01d466a726b850da583995644da0b9c4c2b9125587744508

import type { ConcreteRequest } from 'relay-runtime';
export type CopySpacePermissionsSelectorQuery$variables = Record<PropertyKey, never>;
export type CopySpacePermissionsSelectorQuery$data = {
  readonly hasUserAccessAdminRole: boolean | null | undefined;
  readonly isSiteAdmin: boolean | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type CopySpacePermissionsSelectorQuery = {
  response: CopySpacePermissionsSelectorQuery$data;
  variables: CopySpacePermissionsSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "hasUserAccessAdminRole"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CopySpacePermissionsSelectorQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CopySpacePermissionsSelectorQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a3f93252d4df99f3c4003e78531fafc9",
    "id": "df71df8a37a95b7e01d466a726b850da583995644da0b9c4c2b9125587744508",
    "metadata": {},
    "name": "CopySpacePermissionsSelectorQuery",
    "operationKind": "query",
    "text": "query CopySpacePermissionsSelectorQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
  }
};
})();

(node as any).hash = "868b6122e320d9d148ec3df40d58a181";

export default node;
